"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.maxDateMessage = exports.virtualCardType = exports.DATE_FORMAT = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Lock_1 = __importDefault(require("@mui/icons-material/Lock"));
const Warning_1 = __importDefault(require("@mui/icons-material/Warning"));
const material_1 = require("@mui/material");
const AdapterDayjs_1 = require("@mui/x-date-pickers/AdapterDayjs");
const DatePicker_1 = require("@mui/x-date-pickers/DatePicker");
const demo_1 = require("@mui/x-date-pickers/internals/demo");
const LocalizationProvider_1 = require("@mui/x-date-pickers/LocalizationProvider");
const react_query_1 = require("@tanstack/react-query");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const dayjs_1 = __importDefault(require("dayjs"));
const customParseFormat_1 = __importDefault(require("dayjs/plugin/customParseFormat"));
const lodash_1 = __importDefault(require("lodash"));
const pino_1 = __importDefault(require("pino"));
const react_1 = require("react");
const react_router_1 = require("react-router");
const react_use_1 = require("react-use");
const appConstants_1 = require("../../../../constants/appConstants");
const strings_1 = require("../../../../constants/strings");
const uiConstants_1 = require("../../../../constants/uiConstants");
const StyledTextareaAutosize_1 = require("../../../../material-ui-theme/components/styled/StyledTextareaAutosize");
const codingQuery_1 = require("../../../../queries/codingQuery");
const companyQuery_1 = require("../../../../queries/companyQuery");
const currenciesQuery_1 = require("../../../../queries/currenciesQuery");
const featureQuery_1 = require("../../../../queries/featureQuery");
const requestListQuery_1 = require("../../../../queries/requestListQuery");
const teamQuery_1 = require("../../../../queries/teamQuery");
const userQuery_1 = require("../../../../queries/userQuery");
const codingRepository_1 = __importDefault(require("../../../../repositories/codingRepository"));
const companyRepository_1 = __importDefault(require("../../../../repositories/companyRepository"));
const pageLoader_1 = __importDefault(require("../../../../router/loaders/pageLoader"));
const purchaseValidator_1 = require("../../../../validators/purchaseValidator");
const zustandStore_1 = require("../../../../zustandStore");
const simpleButton_1 = __importDefault(require("../../../atoms/button/simpleButton"));
const formSkeletonLoader_1 = __importDefault(require("./formSkeletonLoader"));
const logger = (0, pino_1.default)();
const lexico = new lexico_1.default();
dayjs_1.default.extend(customParseFormat_1.default);
exports.DATE_FORMAT = globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 'DD-MM-YYYY' : 'YYYY-MM-DD';
const StyledFormLabel = (0, material_1.styled)(material_1.FormLabel)(({ theme }) => ({
    left: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? '0' : '10px',
    top: '0',
    height: '20px',
    paddingTop: '10px',
    lineHeight: '5px',
    textTransform: 'uppercase',
    fontWeight: theme.typography.tsFontWeight.bold,
    fontSize: theme.typography.pxToRem(theme.typography.tsFontSize.mini),
    whiteSpace: 'nowrap',
    wordWrap: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
}));
const StyledFormControl = (0, material_1.styled)(material_1.FormControl)(() => ({
    padding: '4px 0 4px 0',
}));
const StyledBox = (0, material_1.styled)(material_1.Box)(() => ({
    width: 320,
    margin: '0 20px 10px 0',
}));
const filterCardTypes = teamProperties => appConstants_1.cardTypes?.filter(({ feature }) => teamProperties[feature] === 'true');
function normalizeCodingEntry(codingEntry) {
    // TODO: existing coding entries use ID, so let's use entryId and rename later
    const entryId = codingEntry.ID || codingEntry.entryId;
    const entryLabel = codingEntry.path || codingEntry.entryLabel;
    return Object.assign({}, codingEntry, { entryId, entryLabel });
}
function getNormalizedPurchaseRequest(purchaseRequest, currencies, endDateInputValue) {
    const clonedPurchaseRequest = structuredClone(purchaseRequest);
    const normalizedCurrencyFields = lodash_1.default.reduce(clonedPurchaseRequest.currencyFields, function (result, value, key) {
        result[key] = value.replaceAll(/[$,]/g, '');
        return result;
    }, {});
    clonedPurchaseRequest.fields = Object.assign({}, clonedPurchaseRequest.fields, normalizedCurrencyFields);
    clonedPurchaseRequest.state = 'SUBMITTED';
    if (clonedPurchaseRequest.cardType !== 'recurring-use') {
        delete clonedPurchaseRequest.fields.frequency;
    }
    if (!clonedPurchaseRequest.coding) {
        clonedPurchaseRequest.coding = {};
    }
    clonedPurchaseRequest.currency = currencies?.[0] || '';
    const { cardType, coding, fields, profileId, requestId, state, teamId } = clonedPurchaseRequest;
    const endDate = (() => {
        // Special case when navigating out from purchase request form page to another page
        // and then come back to finalize submitting the request, there is an issue that BE
        // returns purchase request with fields empty (end date missing) because the data was
        // not saved yet on BE, so we need to validate and send what's currently in the form.
        // See Jira ticket: https://tradeshift.atlassian.net/browse/GO-5662
        if (fields.endDate) {
            const parts = fields.endDate.split('-');
            if (parts.length === 3) {
                const [first, second, third] = parts;
                if (third.length === 4) {
                    // if the last part is a 4-digit year, rearrange to YYYY-MM-DD
                    return `${third}-${second}-${first}`;
                }
            }
            return fields.endDate;
        }
        else {
            return endDateInputValue.format(exports.DATE_FORMAT);
        }
    })();
    const payload = {
        cardType,
        coding,
        currency: clonedPurchaseRequest.currency,
        fields: {
            ...fields,
            endDate,
        },
        profileId,
        requestId,
        state,
        teamId,
    };
    return payload;
}
function getProviderLimitWithoutPadding(providerLimit, cardType) {
    if (cardType === 'recurring-use') {
        const providerLimitWithoutPadding = (providerLimit * 100) / (subscriptionPadding + 100);
        return lodash_1.default.toNumber(providerLimitWithoutPadding.toFixed(2));
    }
    else {
        return providerLimit;
    }
}
const isInValid = (purchaseRequest, codingLists, isDateValid, isHsbcCardProvider, commentsLength) => {
    const isDescriptionEmpty = lodash_1.default.isEmpty(purchaseRequest.fields.description);
    const isAmountEmpty = lodash_1.default.isEmpty(purchaseRequest.fields.amount);
    const isEndDateInvalid = purchaseRequest.fields.endDate
        ? !(0, dayjs_1.default)(purchaseRequest.fields.endDate, exports.DATE_FORMAT, false).isValid()
        : !isDateValid;
    const isPurposeInvalid = !(0, purchaseValidator_1.validatePurchasePurpose)(purchaseRequest.fields.description);
    const isAmountInvalid = !(0, purchaseValidator_1.validatePurchaseAmount)(purchaseRequest.fields.amount);
    const isRequesterEmailEmpty = lodash_1.default.isEmpty(purchaseRequest.requester.email);
    const isRecurringUseFrequencyEmpty = purchaseRequest.cardType === 'recurring-use' && lodash_1.default.isEmpty(purchaseRequest.fields.frequency);
    let isCodingListInvalid = false;
    if (!isHsbcCardProvider) {
        const hasCodingListEntries = !lodash_1.default.isEmpty(codingLists?.[0]?.entries);
        const isCodingEmpty = lodash_1.default.isEmpty(purchaseRequest.coding);
        const areAllCodingEntriesIncluded = purchaseRequest?.coding
            ? codingLists?.every(entry => Object.keys(purchaseRequest?.coding).includes(entry.ID))
            : false;
        isCodingListInvalid = (hasCodingListEntries && isCodingEmpty) || (!isCodingEmpty && !areAllCodingEntriesIncluded);
    }
    return (isDescriptionEmpty ||
        isAmountEmpty ||
        !isDateValid ||
        isEndDateInvalid ||
        isPurposeInvalid ||
        isAmountInvalid ||
        isRequesterEmailEmpty ||
        isRecurringUseFrequencyEmpty ||
        isCodingListInvalid ||
        commentsLength > COMMENT_MAX_LENGTH);
};
const isSubscriptionEnding = false;
const minDate = (0, dayjs_1.default)().add(2, 'days').format(exports.DATE_FORMAT);
const subscriptionPadding = appConstants_1.payments.subscriptionPaddingPercentage;
const companyProviderLimit = appConstants_1.payments.companyProperties.providerLimit;
exports.virtualCardType = 'defaultExpirationDate';
const COMMENT_MAX_LENGTH = 250;
exports.maxDateMessage = globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
    ? 'Up to 1 year in the future.'
    : 'Up to 4 years in the future.';
const PurchaseRequestForm = () => {
    const initialData = (0, react_router_1.useLoaderData)();
    const { data: teamId } = (0, react_query_1.useQuery)((0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID'));
    const { data: currentTeam } = (0, react_query_1.useQuery)((0, teamQuery_1.teamQuery)({ teamId: teamId?.[0] || '' }));
    const [maxDate, setMaxDate] = (0, react_1.useState)();
    const { data: userData } = (0, react_query_1.useQuery)({
        ...userQuery_1.userQuery,
        initialData: initialData.user,
    });
    const purchaseRequest = (0, zustandStore_1.useZustand)(state => state.request.purchaseRequest);
    const formFields = (0, zustandStore_1.useZustand)(state => state.request.requestFields);
    const cardTypes = (0, zustandStore_1.useZustand)(state => state?.request?.cardTypes);
    const codingLists = (0, zustandStore_1.useZustand)(state => state?.request?.lists);
    const requestErrors = (0, zustandStore_1.useZustand)(state => state?.request?.errors);
    const { data: features } = (0, react_query_1.useQuery)(featureQuery_1.featuresQuery);
    const { data: activeCodingLists = [] } = (0, react_query_1.useQuery)((0, codingQuery_1.getCodingListsQuery)({ skipDisabled: true }));
    const { data: companyPropertiesData } = (0, react_query_1.useQuery)({
        ...(0, companyQuery_1.companyPropertiesQuery)(userData?.companyAccountId, {
            defaultExpirationDate: 'tsgo-virtualcardexprange',
            companyApprovalLimit: 'tsgo-requestlimit',
            cardprovider: 'tsgo-cardprovider',
        }),
        initialData: initialData.companyPropertiesData,
    });
    const commentsLength = purchaseRequest?.fields?.comments?.length || 0;
    const cardProvider = companyPropertiesData.cardprovider;
    const isHsbcCardProvider = cardProvider === 'HSBC';
    const [dateMessage, setDateMessage] = (0, react_1.useState)(exports.maxDateMessage);
    const [isDateValid, setIsDateValid] = (0, react_1.useState)(true);
    const { data: currencies } = (0, react_query_1.useQuery)({
        ...(0, currenciesQuery_1.getCurrenciesQuery)(teamId?.[0] || ''),
        initialData: initialData.currencies,
    });
    const [, startTransition] = (0, react_1.useTransition)();
    const { setCardTypes, setPurchaseRequest, setCompanyProperty, setActiveLists, setNotification, setRequestErrors, setPageLoading, } = (0, zustandStore_1.useZustand)();
    const submitRequest = (0, requestListQuery_1.useSubmitRequestMutation)();
    const [endDateInputValue, setEndDateInputValue] = (0, react_1.useState)((0, dayjs_1.default)(minDate, exports.DATE_FORMAT));
    const today = (0, dayjs_1.default)().startOf('day');
    const minSelectableDate = today.add(2, 'days');
    const shouldDisableDates = (date) => {
        return date.isBefore(minSelectableDate, 'day') || date.isAfter((0, dayjs_1.default)(maxDate, exports.DATE_FORMAT), 'day');
    };
    const populateFormDetails = (0, react_1.useCallback)(() => {
        const types = lodash_1.default.isEmpty(currentTeam?.properties) ? [] : filterCardTypes(currentTeam?.properties);
        setCardTypes(types);
        const cardType = types.find(type => type.cardType === 'multiple-use')?.cardType || types[0]?.cardType;
        const virtualCardExpRange = companyPropertiesData[exports.virtualCardType];
        const ENABLE_VIRTUAL_CARD_EXP_RANGE = features?.ENABLE_VIRTUAL_CARD_EXP_RANGE;
        let endDate;
        if (ENABLE_VIRTUAL_CARD_EXP_RANGE) {
            const virtualCardExpRangeInMonths = virtualCardExpRange / 30;
            endDate = (0, dayjs_1.default)().add(virtualCardExpRangeInMonths, 'month');
        }
        else {
            endDate = isHsbcCardProvider ? (0, dayjs_1.default)().add(1, 'year') : (0, dayjs_1.default)().add(48, 'month');
        }
        setMaxDate(endDate.format(exports.DATE_FORMAT));
        setEndDateInputValue(endDate);
        setPurchaseRequest({
            ...purchaseRequest,
            cardType: cardType,
            currency: currencies?.[0] || '',
            fields: {
                ...purchaseRequest.fields,
                endDate: endDate.format(exports.DATE_FORMAT),
                ends: cardType === appConstants_1.cardTypes[2]?.cardType ? appConstants_1.subscriptionEndings[0]?.key : '',
            },
        });
        if (ENABLE_VIRTUAL_CARD_EXP_RANGE) {
            const rangeObj = appConstants_1.virtualCardExpRanges.find(range => range.id === virtualCardExpRange);
            const rangeMessage = lodash_1.default.get(rangeObj, 'label', 'a date');
            setDateMessage(`Up to ${rangeMessage} in the future`);
        }
    }, [companyPropertiesData, currencies, features, purchaseRequest, currentTeam, isHsbcCardProvider]);
    (0, react_use_1.useShallowCompareEffect)(() => {
        if (!lodash_1.default.isEmpty(companyPropertiesData)) {
            for (const [propertyKey, value] of Object.entries(companyPropertiesData)) {
                setCompanyProperty({
                    key: propertyKey,
                    value: propertyKey === 'showactivity' ? value.toString() : value,
                });
            }
            populateFormDetails();
        }
    }, [companyPropertiesData]);
    (0, react_1.useEffect)(() => {
        const getListEntries = async () => {
            const updatedList = activeCodingLists.map(async (list) => {
                const { ID: listId } = list;
                if (teamId && teamId?.[0]) {
                    const teamEntries = await codingRepository_1.default.getTeamCodingListEntries({ teamId: teamId?.[0], listId });
                    const newEntries = teamEntries?.map(entry => normalizeCodingEntry(entry));
                    return lodash_1.default.isEmpty(newEntries) ? null : { ...list, entries: newEntries };
                }
                return null;
            });
            if (!lodash_1.default.isEmpty(updatedList)) {
                void Promise.all(updatedList).then(function (results) {
                    if (results != null && results.length > 0) {
                        setActiveLists(results);
                    }
                });
            }
        };
        void getListEntries();
    }, [activeCodingLists, setActiveLists, teamId]);
    const submitForm = async () => {
        setRequestErrors({});
        if (!(0, purchaseValidator_1.validatePurchasePurpose)(purchaseRequest.fields.description)) {
            setRequestErrors({ ...requestErrors, fields: { ...requestErrors.fields, description: true } });
            return;
        }
        if (!(0, purchaseValidator_1.validatePurchaseAmount)(purchaseRequest.fields.amount)) {
            setRequestErrors({ ...requestErrors, fields: { ...requestErrors.fields, amount: true } });
            return;
        }
        if (purchaseRequest.fields.endDate && !(0, dayjs_1.default)(purchaseRequest.fields.endDate, exports.DATE_FORMAT, false).isValid()) {
            return;
        }
        const normalizedPurchaseRequest = getNormalizedPurchaseRequest(purchaseRequest, currencies, endDateInputValue);
        const amount = normalizedPurchaseRequest.fields.amount || normalizedPurchaseRequest.fields.InvoiceAmount;
        const requestLimitData = await companyRepository_1.default.getCompanyProperty({
            companyAccountId: userData?.companyAccountId || '',
            propertyKey: appConstants_1.companyPropertyKeys.requestLimit,
        });
        const requestLimit = lodash_1.default.isObject(requestLimitData) ? '' : lodash_1.default.toNumber(requestLimitData);
        if (requestLimit !== '' && requestLimit < amount) {
            return setNotification([
                {
                    type: strings_1.notificationStrings.WARNING,
                    message: `The amount requested was over the company's request limit of ${requestLimit}. Please try again with a lower request amount.`,
                },
            ]);
        }
        const providerLimit = getProviderLimitWithoutPadding(companyProviderLimit, purchaseRequest.cardType);
        if (lodash_1.default.toNumber(amount) > providerLimit) {
            return setNotification([
                {
                    type: strings_1.notificationStrings.WARNING,
                    message: `The amount requested was over the provider's request limit of ${providerLimit}. Please try again with a lower request amount.`,
                },
            ]);
        }
        setPageLoading(true);
        submitRequest.mutate({ requestId: purchaseRequest.requestId, data: normalizedPurchaseRequest }, {
            onSuccess: () => {
                setNotification([
                    {
                        type: strings_1.notificationStrings.SUCCESS,
                        message: lexico.trc('Success message', 'Request created.'),
                    },
                ]);
            },
            onError: error => {
                setNotification([
                    {
                        type: strings_1.notificationStrings.ERROR,
                        message: lexico.tr('Request failed to be created.'),
                    },
                ]);
                logger.error({ error });
            },
            onSettled: () => setPageLoading(false),
        });
    };
    return ((0, jsx_runtime_1.jsxs)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: [cardProvider ? ((0, jsx_runtime_1.jsxs)(StyledBox, { style: {
                    boxSizing: 'content-box',
                    ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                        ? {
                            paddingRight: '6px',
                            marginRight: '0',
                            paddingLeft: '6px',
                            paddingTop: '6px',
                        }
                        : {}),
                }, children: [(0, jsx_runtime_1.jsxs)(StyledFormControl, { children: [(0, jsx_runtime_1.jsx)(StyledFormLabel, { children: isHsbcCardProvider ? strings_1.walletStrings.BUSINESS_JUSTIFICATION : formFields?.[0]?.label }), (0, jsx_runtime_1.jsx)(material_1.TextField, { name: "purpose", variant: "outlined", error: requestErrors?.fields?.description, onChange: event => setPurchaseRequest({
                                    ...purchaseRequest,
                                    fields: {
                                        ...purchaseRequest.fields,
                                        description: event.target.value,
                                    },
                                }), required: true }, "field-1"), !(0, purchaseValidator_1.validatePurchasePurpose)(purchaseRequest.fields.description) && ((0, jsx_runtime_1.jsx)(material_1.Alert, { severity: "error", sx: { pl: 1 }, variant: 'outlined', icon: (0, jsx_runtime_1.jsx)(Warning_1.default, { fontSize: "small" }), children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "caption", sx: {
                                        color: 'error',
                                    }, children: lexico.trc('Validation error message', 'The following characters are not allowed: " ’ / < > &, Please try again') }) }))] }, formFields?.[0]?.label), (0, jsx_runtime_1.jsxs)(StyledFormControl, { children: [(0, jsx_runtime_1.jsx)(StyledFormLabel, { children: formFields?.[1]?.label }), (0, jsx_runtime_1.jsx)(material_1.TextField, { name: "amount", error: requestErrors?.fields?.amount, onChange: event => setPurchaseRequest({
                                    ...purchaseRequest,
                                    fields: {
                                        ...purchaseRequest.fields,
                                        amount: event.target.value,
                                    },
                                }), variant: "outlined", required: true, slotProps: {
                                    input: {
                                        endAdornment: (0, jsx_runtime_1.jsx)(material_1.InputAdornment, { position: "end", children: currencies?.[0] || '' }),
                                    },
                                } }, "field-2"), !(0, purchaseValidator_1.validatePurchaseAmount)(purchaseRequest.fields.amount) && ((0, jsx_runtime_1.jsx)(material_1.Alert, { severity: "error", sx: { pl: 1 }, variant: 'outlined', icon: (0, jsx_runtime_1.jsx)(Warning_1.default, { fontSize: "small" }), children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "caption", sx: {
                                        color: 'error',
                                    }, children: lexico.trc('Validation error message', 'Amount field is invalid') }) }))] }, formFields?.[1]?.label), (0, jsx_runtime_1.jsxs)(StyledFormControl, { children: [(0, jsx_runtime_1.jsx)(StyledFormLabel, { children: "Card type" }), (0, jsx_runtime_1.jsx)(material_1.Select, { id: "card-type", sx: { ml: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 0 : 1 }, value: purchaseRequest.cardType || '', onChange: event => {
                                    setPurchaseRequest({
                                        ...purchaseRequest,
                                        cardType: event.target.value,
                                        fields: {
                                            ...purchaseRequest.fields,
                                            ends: event.target.value === appConstants_1.cardTypes[2]?.cardType ? appConstants_1.subscriptionEndings[0]?.key : '',
                                        },
                                    });
                                }, disabled: cardTypes?.length === 1, required: true, children: cardTypes?.map(type => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: type.cardType, children: type.label }, type.cardType))) }, "field-3")] }, "card-type"), !lodash_1.default.isEmpty(appConstants_1.cardTypes[2]) &&
                        currentTeam?.properties?.[appConstants_1.cardTypes[2]?.feature] &&
                        purchaseRequest.cardType === appConstants_1.cardTypes[2]?.cardType ? ((0, jsx_runtime_1.jsxs)(StyledFormControl, { children: [(0, jsx_runtime_1.jsx)(StyledFormLabel, { children: formFields?.[3]?.label }), (0, jsx_runtime_1.jsx)(material_1.Select, { id: "frequency", sx: { ml: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 0 : 1 }, value: purchaseRequest.fields.frequency || '', onChange: event => setPurchaseRequest({
                                    ...purchaseRequest,
                                    fields: {
                                        ...purchaseRequest.fields,
                                        frequency: event.target.value,
                                    },
                                }), required: true, children: appConstants_1.subscriptionFrequencies?.map(type => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: type.key, children: type.label }, type.key))) }, "field-4")] }, formFields?.[3]?.label)) : null, !lodash_1.default.isEmpty(appConstants_1.cardTypes[2]) &&
                        currentTeam?.properties?.[appConstants_1.cardTypes[2]?.feature] &&
                        purchaseRequest.cardType === appConstants_1.cardTypes[2]?.cardType &&
                        isSubscriptionEnding ? ((0, jsx_runtime_1.jsxs)(StyledFormControl, { children: [(0, jsx_runtime_1.jsx)(StyledFormLabel, { children: formFields?.[4]?.label }), (0, jsx_runtime_1.jsx)(material_1.Select, { name: "ends", value: purchaseRequest.fields.ends || '', onChange: event => setPurchaseRequest({
                                    ...purchaseRequest,
                                    fields: {
                                        ...purchaseRequest.fields,
                                        ends: event.target.value,
                                    },
                                }), required: true, children: appConstants_1.subscriptionEndings?.map(type => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: type.key, children: type.label }, type.key))) }, "field-5")] }, formFields?.[4]?.label)) : null, (0, jsx_runtime_1.jsxs)(StyledFormControl, { children: [(0, jsx_runtime_1.jsx)(StyledFormLabel, { children: "End date" }), (0, jsx_runtime_1.jsx)(material_1.Box, { component: "div", sx: {
                                    width: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? '100%' : 'calc(100% + 20px)',
                                    boxSizing: 'border-box',
                                }, children: (0, jsx_runtime_1.jsxs)(LocalizationProvider_1.LocalizationProvider, { dateAdapter: AdapterDayjs_1.AdapterDayjs, children: [(0, jsx_runtime_1.jsx)(demo_1.DemoContainer, { components: ['DatePicker'], children: maxDate && ((0, jsx_runtime_1.jsx)(DatePicker_1.DatePicker, { value: (0, dayjs_1.default)(endDateInputValue, exports.DATE_FORMAT), onError: newError => {
                                                    setIsDateValid(newError === null);
                                                }, shouldDisableDate: shouldDisableDates, minDate: minSelectableDate, maxDate: (0, dayjs_1.default)(maxDate, exports.DATE_FORMAT), format: exports.DATE_FORMAT, sx: { minHeight: '50px' }, onChange: value => {
                                                    if (!value) {
                                                        return;
                                                    }
                                                    setEndDateInputValue(value);
                                                    startTransition(() => {
                                                        setPurchaseRequest({
                                                            ...purchaseRequest,
                                                            fields: {
                                                                ...purchaseRequest.fields,
                                                                endDate: (0, dayjs_1.default)(value).format(exports.DATE_FORMAT),
                                                            },
                                                        });
                                                    });
                                                } }, "field-6")) }), (0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", sx: { ml: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 0 : 1 }, children: (0, jsx_runtime_1.jsx)("ul", { children: (0, jsx_runtime_1.jsx)("li", { children: dateMessage }) }) })] }) })] }, "end-date"), (0, jsx_runtime_1.jsxs)(StyledFormControl, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, { component: 'span', sx: { display: 'flex', justifyContent: 'space-between' }, children: [(0, jsx_runtime_1.jsx)(StyledFormLabel, { children: formFields?.[2]?.label }), (0, jsx_runtime_1.jsx)(StyledFormLabel, { children: "(Optional)" })] }), (0, jsx_runtime_1.jsx)(StyledTextareaAutosize_1.StyledTextareaAutosize, { name: "comments", minRows: 5, value: purchaseRequest.fields.comments, sx: [
                                    {
                                        border: '1px solid rgba(0, 0, 0, 0.23)',
                                        marginLeft: '10px',
                                        padding: '5px 10px',
                                        '& .MuiOutlinedInput-root': {
                                            padding: '10px 0px',
                                        },
                                    },
                                    globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                        ? {
                                            marginLeft: 0,
                                        }
                                        : {},
                                ], onChange: event => {
                                    const newValue = event.target.value.slice(0, COMMENT_MAX_LENGTH);
                                    startTransition(() => {
                                        setPurchaseRequest({
                                            ...purchaseRequest,
                                            fields: {
                                                ...purchaseRequest.fields,
                                                comments: newValue,
                                            },
                                        });
                                    });
                                } }, "field-7"), (0, jsx_runtime_1.jsxs)(material_1.Typography, { variant: "caption", align: "right", sx: {
                                    color: 'textSecondary',
                                }, children: [commentsLength, "/", COMMENT_MAX_LENGTH] }), commentsLength >= COMMENT_MAX_LENGTH ? ((0, jsx_runtime_1.jsx)(material_1.Alert, { severity: "warning", sx: { mt: 1 }, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "caption", children: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                        ? strings_1.walletStrings.HSBC_MAXIMUM_CHARS
                                        : strings_1.walletStrings.MAXIMUM_CHARS }) })) : null] }, formFields?.[2]?.label), isHsbcCardProvider
                        ? null
                        : codingLists?.map(list => ((0, jsx_runtime_1.jsxs)(StyledFormControl, { children: [(0, jsx_runtime_1.jsx)(StyledFormLabel, { children: list?.name }), list?.ID ? ((0, jsx_runtime_1.jsx)(material_1.Select, { id: list?.ID, sx: { ml: 1 }, value: purchaseRequest?.coding?.[list?.ID]?.ID || '', onChange: event => {
                                        const entry = list?.entries?.find(el => el.entryId === event.target.value);
                                        setPurchaseRequest({
                                            ...purchaseRequest,
                                            coding: {
                                                ...purchaseRequest?.coding,
                                                [list.ID || '']: {
                                                    ID: entry?.ID,
                                                    listId: list?.ID,
                                                    listLabel: list?.name,
                                                    path: entry?.path,
                                                },
                                            },
                                        });
                                    }, children: list?.entries?.map(type => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: type?.entryId, children: type?.entryLabel }, type?.entryId))) }, "field-8")) : null] }, list?.name))), (0, jsx_runtime_1.jsxs)(StyledFormControl, { children: [(0, jsx_runtime_1.jsx)(StyledFormLabel, { children: "Assigned to" }), (0, jsx_runtime_1.jsx)(material_1.TextField, { name: "assigned-to", disabled: true, value: purchaseRequest.requester.teamApproverEmail, variant: "outlined", slotProps: {
                                    input: {
                                        endAdornment: ((0, jsx_runtime_1.jsx)(material_1.InputAdornment, { position: "end", children: (0, jsx_runtime_1.jsx)(Lock_1.default, {}) })),
                                    },
                                } }, "field-9")] }, "assigned-to")] })) : ((0, jsx_runtime_1.jsx)(formSkeletonLoader_1.default, {})), (0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "submitRequest-button", onClick: submitForm, disabled: isInValid(purchaseRequest, codingLists, isDateValid, isHsbcCardProvider, purchaseRequest.fields.comments?.length || 0), color: uiConstants_1.UI_BUTTON_PRIMARY, style: {
                    width: '100%',
                    ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                        ? {
                            marginBottom: '16px',
                            marginLeft: '6px',
                            width: 'calc(100% - 12px)',
                        }
                        : {}),
                }, label: 'Submit Request' })] }));
};
exports.default = (0, react_1.memo)(PurchaseRequestForm);
